import { ActionContext } from "vuex";
import TYPES from "./types";
import { Location, IpInfo } from "~/types/user";
import request from "~/utils/request";
import { RootState } from '~/store/index'
import { config as api } from "~/const/apis";

interface State {
  clientIP: string | undefined,
  userLocation: null | Location;
  needCookieBanner: boolean;
}

export const state = (): State => ({
  clientIP: '',
  userLocation: null,
  needCookieBanner: true
});

export const mutations = {
  [TYPES.SET_CLIENT_IP](state: State, clientIP: string) {
    state.clientIP = clientIP;
  },
  [TYPES.SET_USER_LOCATION](state: State, userLocation: Location) {
    state.userLocation = userLocation;
  },
  [TYPES.SET_NEED_COOKIE_BANNER](state: State, needCookieBanner: boolean) {
    state.needCookieBanner = needCookieBanner;
  }
};

export const getters = {
  userCountry(state: State) {
    return state?.userLocation?.Country?.Code || "";
  }
};

export const actions = {
  async getIpInfo({ state, commit }: ActionContext<State, RootState>) {
    if (state.userLocation) return
    try {
      const info: IpInfo = await request.get(api.get_ip_info);
      if (info?.code === 0 && info.data?.Location) {
        commit(TYPES.SET_CLIENT_IP, info.data.clientIP);
        commit(TYPES.SET_USER_LOCATION, info.data.Location);
      }
      return info;
    } catch (e) {
      console.error(e)
      return {
        code: -1,
        data: {},
        msg: e.message + e.stack
      }
    }
  }
};
